<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import AvailabilityBase from '../../../../availability/components/AvailabilityBase.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
        childNavItems: [
            {
                label: 'Employees',
                route: '/(app)/people/employees/',
            },
            {
                label: 'Availability',
                route: '/(app)/people/availability/',
            },
            {
                label: 'Broadcasts',
                route: '/(app)/people/broadcasts/',
            },
            {
                label: 'Time Off',
                route: '/(app)/people/time-off/',
            },
        ],
    }
})
</script>

<template>
  <AvailabilityBase />
</template>